import merge from 'lodash/merge';
import defaultTheme from 'tailwindcss/defaultTheme';

import currentTheme from '../../tailwind.config';

const tailwindConfig = merge(defaultTheme, currentTheme.theme?.extend);
export default tailwindConfig;
